import {Module} from 'vuex';
import {Api} from 'modules/spravochnik/dt-front-page-generator/src/Api';

interface OpenDataStateInterface {
    data: any,
    loaded: boolean,
}

const openDataModule: Module<OpenDataStateInterface, any> = {
    namespaced: true,
    state: {
        data: {},
        loaded: false,
    },
    actions: {
        async loadOpenDataCategories({commit, state}) {
            if (state.loaded) {
                commit('setOpenData', state.data);
                return Promise.resolve();
            }

            const list = await Api.fetchOpenDataCategories();
            commit('setOpenData', list);
        },
    },
    mutations: {
        setOpenData(state: OpenDataStateInterface, data: Array<any>) {
            state.data = data;
            state.loaded = true;
        }
    },
}

export {openDataModule, OpenDataStateInterface};
